import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../../utils/Draft.ext.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  listOfvhqybd2zx248 as listOf_0,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  flatten2dh4kibw1u0qq as flatten,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  asyncz02dsa2nb2zt as async,
  launch1c91vkjzdi9sd as launch,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope284yy3flyb2v2 as coroutineScope,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { withWritedlio9p0oewet as withWrite } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  intercepted2ogpsikxxj4u0 as intercepted,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  NotificationFrequency6nobdojsdzj9 as NotificationFrequency,
  Companion_getInstance2a6946bmnnmyk as Companion_getInstance,
  UserEventType3ayinm14vltts as UserEventType,
  EventSubscription13rxmq485x98c as EventSubscription,
} from '../../../../../../crowpay-shared/com/crowpay/notifications/shared.mjs';
import {
  get_REQUIRED1bmfj0gf2ut8d as get_REQUIRED,
  get_CONTRACTOR_REQUIRED34hzo4f48qqcw as get_CONTRACTOR_REQUIRED,
  get_HOMEOWNER_REQUIREDhb3x1wu860rc as get_HOMEOWNER_REQUIRED,
  SharedEvents_getInstance1170khu4x8la2 as SharedEvents_getInstance,
  WithReminders3bc704fti0zb0 as WithReminders,
  Event1b89my6urnj4w as Event,
  get_roleRequirementzb3lvemsijd7 as get_roleRequirement,
} from '../../../../../../crowpay-shared/com/crowpay/notificationHelpers.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  containsAny27n115ngkvovr as containsAny,
  resize3py5p2yrjp6p7 as resize,
  Action1a4ymn5nx79hk as Action,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
} from '../../../utils/utils.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  _Constant___get_value__impl__gl47rj3u5ywr3ls9g1y as _Constant___get_value__impl__gl47rj,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../sdk/errors.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import {
  serializerOrContextual1whp5jyfp32aq as serializerOrContextual,
  tryTypeParameterSerializers1jrcyh9alxuh0 as tryTypeParameterSerializers,
} from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  EventSubscription_email3bp1h34w94knn as EventSubscription_email,
  EventSubscription_sms1dq2yae9wjcc7 as EventSubscription_sms,
  EventSubscription_push36iueneirbwc as EventSubscription_push,
  EventSubscription_frequencyf8n11hvgmqn1 as EventSubscription_frequency,
  EventSubscription__id1u3p9t167zyq1 as EventSubscription__id,
} from '../../../../../../crowpay-shared/com/crowpay/notifications/EventSubscriptionFields.mjs';
import { lensPath2kkrykycsgvs9 as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  first58ocm7j58k3q as first,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../components/nav/crowpay.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../dialogs/GenericConfirmationDialog.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from '../../dialogs/GenericDialog.mjs';
import { get_loggedInAsContractorugpccxnrffn6 as get_loggedInAsContractor } from '../../../selectedContractor.mjs';
import {
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
  ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance,
} from './ProjectView.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atBottomzb604i67rgu3 as get_atBottom,
  get_centered1xfu6or5nc0lq as get_centered,
  forEach37zw770vd3h4l as forEach,
  get_atBottomEnd1uhyy6gazj2pk as get_atBottomEnd,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_bold1rri6ahk98puv as get_bold,
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_compact3lsezez8nz8b6 as get_compact,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
  title1nssp3ryhwuqj as title,
} from '../../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  hintPopover2584paxgnbc51 as hintPopover,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  UnselectedSemantic_getInstancexnnq5hq6ryv2 as UnselectedSemantic_getInstance,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  times2ukvaf6yk96p2 as times,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import {
  get_messageBubble2n8cudx7fa50g as get_messageBubble,
  get_notificationBellomfwee2yer2u as get_notificationBell,
  get_lock2o8g4iwxfra2x as get_lock,
  get_envelope3rntmtwdt9spu as get_envelope,
  get_speechBubble3o8vs4xcx9j9o as get_speechBubble,
  get_bell1eawz13l3zocu as get_bell,
  get_padlock2mtosxycshh94 as get_padlock,
} from '../../../icons.mjs';
import { NoHoverSemantic_getInstance1icuasw0irscx as NoHoverSemantic_getInstance } from '../../theming/appTheme.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import {
  get_padded3m3frjnjujncx as get_padded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { Switchrdgqp2jwylc6 as Switch } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Switch.commonHtml.mjs';
import { UserEventType_userv06183wfmbun as UserEventType_user } from '../../../../../../crowpay-shared/com/crowpay/notifications/UserEventTypeFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ViewLegalDocument2rrxowcqg42d as ViewLegalDocument } from './ViewLegalDocument.mjs';
import { PurpleSelectButtons_getInstance1ga9xxb87mrwe as PurpleSelectButtons_getInstance } from '../../theming/sections.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../theming/buttons.mjs';
import { RowWrapping1cfo2cqk4jxme as RowWrapping } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Column.commonHtml.mjs';
import { get_entries19ryowjr3zlbs as get_entries } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_save__qhzefp($this, $completion) {
  var tmp;
  try {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp_0 = await_0(this_0, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp$ret$0 = tmp_0;
    var tmp_1 = pushChanges($this.kj8_1, tmp$ret$0.lfw_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = emptyList();
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Exception()) {
      var e = $p;
      tmp_2 = listOf_0($this.k20());
    } else {
      throw $p;
    }
    tmp = tmp_2;
  }
  return tmp;
}
var SubscriptionSetting$Base$email$slambdaClass;
function SubscriptionSetting$Base$email$slambda() {
  if (SubscriptionSetting$Base$email$slambdaClass === VOID) {
    class $ {
      afz($this$withWrite, it, $completion) {
        return Unit_instance;
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    SubscriptionSetting$Base$email$slambdaClass = $;
  }
  return SubscriptionSetting$Base$email$slambdaClass;
}
function SubscriptionSetting$Base$email$slambda_0() {
  var i = new (SubscriptionSetting$Base$email$slambda())();
  var l = ($this$withWrite, it, $completion) => i.afz($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8($this, $this$withWrite, value, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.xj8_1.qj8_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp_0 = $this.yj8_1(element).gah(value, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$withWrite, value, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.zj8_1.qj8_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp_0 = element.aj9().gah(value, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$coroutineScope, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.bj9_1.qj8_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$1 = async($this$coroutineScope, VOID, VOID, SubscriptionSetting$Group$save$slambda$slambda_0(item));
    destination.v(tmp$ret$1);
  }
  var tmp_0 = awaitAll(destination, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return flatten(tmp_0);
}
var SubscriptionSetting$Group$save$slambda$slambdaClass;
function SubscriptionSetting$Group$save$slambda$slambda() {
  if (SubscriptionSetting$Group$save$slambda$slambdaClass === VOID) {
    class $ {
      constructor($it) {
        this.cj9_1 = $it;
      }
      wah($this$async, $completion) {
        return this.cj9_1.eh4($completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SubscriptionSetting$Group$save$slambda$slambdaClass = $;
  }
  return SubscriptionSetting$Group$save$slambda$slambdaClass;
}
function SubscriptionSetting$Group$save$slambda$slambda_0($it) {
  var i = new (SubscriptionSetting$Group$save$slambda$slambda())($it);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
function setting($this, getSetting) {
  var tmp = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj($this.qj8_1);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!$this$remember.baj(element.dj9())) {
        destination.v(element);
      }
    }
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(destination, Collection())) {
        tmp = destination.i1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$3 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = destination.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        if (!$this$remember.baj(getSetting(element_0))) {
          tmp$ret$3 = false;
          break $l$block_0;
        }
      }
      tmp$ret$3 = true;
    }
    return tmp$ret$3;
  });
  return withWrite(tmp, SubscriptionSetting$Group$setting$slambda_0($this, getSetting));
}
function *_generator_discard__skcevq($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.qj8_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp_0 = element.ej9($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
var SubscriptionSetting$Group$setting$slambdaClass;
function SubscriptionSetting$Group$setting$slambda() {
  if (SubscriptionSetting$Group$setting$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $getSetting) {
        this.xj8_1 = this$0;
        this.yj8_1 = $getSetting;
      }
      afz($this$withWrite, value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withWrite, value), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    SubscriptionSetting$Group$setting$slambdaClass = $;
  }
  return SubscriptionSetting$Group$setting$slambdaClass;
}
function SubscriptionSetting$Group$setting$slambda_0(this$0, $getSetting) {
  var i = new (SubscriptionSetting$Group$setting$slambda())(this$0, $getSetting);
  var l = ($this$withWrite, value, $completion) => i.afz($this$withWrite, value, $completion);
  l.$arity = 2;
  return l;
}
function SubscriptionSetting$Group$email$lambda(it) {
  return it.l92();
}
function SubscriptionSetting$Group$sms$lambda(it) {
  return it.fj9();
}
function SubscriptionSetting$Group$push$lambda(it) {
  return it.gj9();
}
var SubscriptionSetting$Group$frequency$slambdaClass;
function SubscriptionSetting$Group$frequency$slambda() {
  if (SubscriptionSetting$Group$frequency$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.zj8_1 = this$0;
      }
      hj9($this$withWrite, value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$withWrite, value), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.hj9(tmp, p2 instanceof NotificationFrequency() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    SubscriptionSetting$Group$frequency$slambdaClass = $;
  }
  return SubscriptionSetting$Group$frequency$slambdaClass;
}
function SubscriptionSetting$Group$frequency$slambda_0(this$0) {
  var i = new (SubscriptionSetting$Group$frequency$slambda())(this$0);
  var l = ($this$withWrite, value, $completion) => i.hj9($this$withWrite, value, $completion);
  l.$arity = 2;
  return l;
}
var SubscriptionSetting$Group$save$slambdaClass;
function SubscriptionSetting$Group$save$slambda() {
  if (SubscriptionSetting$Group$save$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.bj9_1 = this$0;
      }
      wah($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$coroutineScope), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SubscriptionSetting$Group$save$slambdaClass = $;
  }
  return SubscriptionSetting$Group$save$slambdaClass;
}
function SubscriptionSetting$Group$save$slambda_0(this$0) {
  var i = new (SubscriptionSetting$Group$save$slambda())(this$0);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var BaseClass;
function Base() {
  if (BaseClass === VOID) {
    class $ {
      constructor(eventInfo, subscriptions, lens) {
        this.hj8_1 = eventInfo;
        this.ij8_1 = subscriptions;
        this.jj8_1 = _Constant___init__impl__v45mub(containsAny(this.hj8_1.i9g_1, lens.xgj() ? setOf([get_REQUIRED(Companion_getInstance()), get_HOMEOWNER_REQUIRED(Companion_getInstance())]) : setOf([get_REQUIRED(Companion_getInstance()), get_CONTRACTOR_REQUIRED(Companion_getInstance())])));
        var tmp = this;
        tmp.kj8_1 = Draft(($this$Draft) => {
          var session = $this$Draft.baj(get_session());
          var tmp0_safe_receiver = $this$Draft.baj(this.ij8_1).p3(new (UserEventType())(session.efv_1, this.hj8_1.f94()));
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.also' call
            if (this.hj8_1.equals(SharedEvents_getInstance().w9g_1)) {
              println(tmp0_safe_receiver);
            }
            tmp = tmp0_safe_receiver;
          }
          var tmp1_elvis_lhs = tmp;
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            var message = 'No subscription found for ' + this.hj8_1.h9g_1;
            throw NotFound().nfx(getKClass(EventSubscription()), message);
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          return tmp_0;
        });
        var tmp_0 = this;
        var tmp_1;
        if (_Constant___get_value__impl__gl47rj(this.jj8_1)) {
          var tmp_2 = _Constant___init__impl__v45mub(true);
          tmp_1 = withWrite(new (Constant())(tmp_2), SubscriptionSetting$Base$email$slambda_0());
        } else {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = this.kj8_1;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(EventSubscription()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), false));
          var tmp$ret$2 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          // Inline function 'com.crowpay.notifications.email' call
          var this_1 = new (DataClassPathSelf())(tmp$ret$2);
          // Inline function 'kotlin.let' call
          var tmp_4 = ensureNotNull(tryTypeParameterSerializers(this_1.j2j()))[0];
          var tmp$ret$7 = this_1.prop(new (EventSubscription_email())(isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE()));
          tmp_1 = lensPath(this_0, tmp$ret$7);
        }
        tmp_0.lj8_1 = tmp_1;
        var tmp_5 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_2 = this.kj8_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_6 = serializerOrContextual(createKType(getKClass(EventSubscription()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), false));
        var tmp$ret$9 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
        // Inline function 'com.crowpay.notifications.sms' call
        var this_3 = new (DataClassPathSelf())(tmp$ret$9);
        // Inline function 'kotlin.let' call
        var tmp_7 = ensureNotNull(tryTypeParameterSerializers(this_3.j2j()))[0];
        var tmp$ret$14 = this_3.prop(new (EventSubscription_sms())(isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE()));
        tmp_5.mj8_1 = lensPath(this_2, tmp$ret$14);
        var tmp_8 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_4 = this.kj8_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_9 = serializerOrContextual(createKType(getKClass(EventSubscription()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), false));
        var tmp$ret$16 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
        // Inline function 'com.crowpay.notifications.push' call
        var this_5 = new (DataClassPathSelf())(tmp$ret$16);
        // Inline function 'kotlin.let' call
        var tmp_10 = ensureNotNull(tryTypeParameterSerializers(this_5.j2j()))[0];
        var tmp$ret$21 = this_5.prop(new (EventSubscription_push())(isInterface(tmp_10, KSerializer()) ? tmp_10 : THROW_CCE()));
        tmp_8.nj8_1 = lensPath(this_4, tmp$ret$21);
        var tmp_11 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_6 = this.kj8_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_12 = serializerOrContextual(createKType(getKClass(EventSubscription()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), false));
        var tmp$ret$23 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
        // Inline function 'com.crowpay.notifications.frequency' call
        var this_7 = new (DataClassPathSelf())(tmp$ret$23);
        // Inline function 'kotlin.let' call
        var tmp_13 = ensureNotNull(tryTypeParameterSerializers(this_7.j2j()))[0];
        var tmp$ret$28 = this_7.prop(new (EventSubscription_frequency())(isInterface(tmp_13, KSerializer()) ? tmp_13 : THROW_CCE()));
        tmp_11.oj8_1 = lensPath(this_6, tmp$ret$28);
      }
      k20() {
        return this.hj8_1.j9g_1;
      }
      ij9() {
        return this.jj8_1;
      }
      dj9() {
        return new (Constant())(this.ij9());
      }
      l92() {
        return this.lj8_1;
      }
      fj9() {
        return this.mj8_1;
      }
      gj9() {
        return this.nj8_1;
      }
      aj9() {
        return this.oj8_1;
      }
      eh4($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_save__qhzefp.bind(VOID, this), $completion);
      }
      ej9($completion) {
        this.kj8_1.lai();
        return Unit_instance;
      }
      jj9() {
        return this.kj8_1.aak();
      }
    }
    initMetadataForClass($, 'Base', VOID, VOID, VOID, [0]);
    BaseClass = $;
  }
  return BaseClass;
}
var GroupClass;
function Group() {
  if (GroupClass === VOID) {
    class $ {
      constructor(name, settings) {
        this.pj8_1 = name;
        this.qj8_1 = settings;
        var tmp = this;
        tmp.rj8_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0 = $this$remember.baj(this.qj8_1);
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if ($this$remember.baj(element.dj9())) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          return tmp$ret$0;
        });
        var tmp_0 = this;
        tmp_0.sj8_1 = setting(this, SubscriptionSetting$Group$email$lambda);
        var tmp_1 = this;
        tmp_1.tj8_1 = setting(this, SubscriptionSetting$Group$sms$lambda);
        var tmp_2 = this;
        tmp_2.uj8_1 = setting(this, SubscriptionSetting$Group$push$lambda);
        var tmp_3 = this;
        var tmp_4 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(first($this$remember.baj(this.qj8_1)).aj9()));
        tmp_3.vj8_1 = withWrite(tmp_4, SubscriptionSetting$Group$frequency$slambda_0(this));
        var tmp_5 = this;
        tmp_5.wj8_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0 = $this$remember.baj(this.qj8_1);
          var tmp$ret$2;
          $l$block_2: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$2 = false;
              break $l$block_2;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if ($this$remember.baj(element.jj9())) {
                tmp$ret$2 = true;
                break $l$block_2;
              }
            }
            tmp$ret$2 = false;
          }
          return tmp$ret$2;
        });
      }
      k20() {
        return this.pj8_1;
      }
      dj9() {
        return this.rj8_1;
      }
      l92() {
        return this.sj8_1;
      }
      fj9() {
        return this.tj8_1;
      }
      gj9() {
        return this.uj8_1;
      }
      aj9() {
        return this.vj8_1;
      }
      eh4($completion) {
        return coroutineScope(SubscriptionSetting$Group$save$slambda_0(this), $completion);
      }
      ej9($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_discard__skcevq.bind(VOID, this), $completion);
      }
      jj9() {
        return this.wj8_1;
      }
    }
    initMetadataForClass($, 'Group', VOID, VOID, VOID, [0]);
    GroupClass = $;
  }
  return GroupClass;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.kj9_1.sj8_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var enabled = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.kj9_1.qj8_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp_1 = element.l92().gah(!enabled, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, confirmed, $completion) {
  if (confirmed) {
    var tmp = $this.lj9_1.tj8_1.gah(true, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  // Inline function 'kotlin.coroutines.resume' call
  var this_0 = $this.mj9_1;
  // Inline function 'kotlin.Companion.success' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
  this_0.rc(tmp$ret$0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.nj9_1.tj8_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.oj9_1.fiv_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp0 = tmp_0;
    var tmp$ret$2;
    $l$block_2: {
      // Inline function 'kotlin.collections.none' call
      var tmp_1;
      if (isInterface(tmp0, Collection())) {
        tmp_1 = tmp0.i1();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$2 = true;
        break $l$block_2;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_2 = element.qj8_1;
        var tmp_2 = await_0(this_2, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        var tmp0_0 = tmp_2;
        var tmp$ret$4;
        $l$block_1: {
          // Inline function 'kotlin.collections.any' call
          var tmp_3;
          if (isInterface(tmp0_0, Collection())) {
            tmp_3 = tmp0_0.i1();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$4 = false;
            break $l$block_1;
          }
          var _iterator__ex2g4s_0 = tmp0_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            // Inline function 'com.lightningkite.reactive.context.invoke' call
            var this_3 = element_0.fj9();
            var tmp_4 = await_0(this_3, $completion);
            if (tmp_4 === get_COROUTINE_SUSPENDED())
              tmp_4 = yield tmp_4;
            if (tmp_4) {
              tmp$ret$4 = true;
              break $l$block_1;
            }
          }
          tmp$ret$4 = false;
        }
        if (tmp$ret$4) {
          tmp$ret$2 = false;
          break $l$block_2;
        }
      }
      tmp$ret$2 = true;
    }
    if (tmp$ret$2) {
      // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
      // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
      var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
      cancellable.ra5();
      var tmp_5 = get_dialogStack();
      tmp_5.xgd(new (GenericConfirmationDialog())('Enable SMS Alerts?', 'You will receive event notifications from Stoze via SMS to your phone number. Message and data rates may apply. You can unsubscribe at any time by toggling off alerts in your Notifications Settings or replying STOP to any SMS.', VOID, 'Enable SMS Alerts', 'Nevermind', VOID, VOID, VOID, VOID, VOID, NotificationSubscriptionSettings$renderSettingsControls$slambda$slambda_0($this.nj9_1, cancellable)));
      var tmp$ret$9 = cancellable.sa5();
      var tmp_6 = returnIfSuspended(tmp$ret$9, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
    } else {
      var tmp_7 = $this.nj9_1.tj8_1.gah(true, $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
    }
  } else {
    var tmp_8 = $this.nj9_1.tj8_1.gah(false, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
  }
  return Unit_instance;
}
var NotificationSubscriptionSettings$renderSettingsControls$slambda$slambdaClass;
function NotificationSubscriptionSettings$renderSettingsControls$slambda$slambda() {
  if (NotificationSubscriptionSettings$renderSettingsControls$slambda$slambdaClass === VOID) {
    class $ {
      constructor($group, $cont) {
        this.lj9_1 = $group;
        this.mj9_1 = $cont;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    NotificationSubscriptionSettings$renderSettingsControls$slambda$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$renderSettingsControls$slambda$slambdaClass;
}
function NotificationSubscriptionSettings$renderSettingsControls$slambda$slambda_0($group, $cont) {
  var i = new (NotificationSubscriptionSettings$renderSettingsControls$slambda$slambda())($group, $cont);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, confirmed, $completion) {
  if (confirmed) {
    var tmp = $this.pj9_1.fj9().gah(true, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  // Inline function 'kotlin.coroutines.resume' call
  var this_0 = $this.qj9_1;
  // Inline function 'kotlin.Companion.success' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
  this_0.rc(tmp$ret$0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.rj9_1.fj9();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.sj9_1.fiv_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp0 = tmp_0;
    var tmp$ret$2;
    $l$block_2: {
      // Inline function 'kotlin.collections.none' call
      var tmp_1;
      if (isInterface(tmp0, Collection())) {
        tmp_1 = tmp0.i1();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$2 = true;
        break $l$block_2;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_2 = element.qj8_1;
        var tmp_2 = await_0(this_2, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        var tmp0_0 = tmp_2;
        var tmp$ret$4;
        $l$block_1: {
          // Inline function 'kotlin.collections.any' call
          var tmp_3;
          if (isInterface(tmp0_0, Collection())) {
            tmp_3 = tmp0_0.i1();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$4 = false;
            break $l$block_1;
          }
          var _iterator__ex2g4s_0 = tmp0_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            // Inline function 'com.lightningkite.reactive.context.invoke' call
            var this_3 = element_0.fj9();
            var tmp_4 = await_0(this_3, $completion);
            if (tmp_4 === get_COROUTINE_SUSPENDED())
              tmp_4 = yield tmp_4;
            if (tmp_4) {
              tmp$ret$4 = true;
              break $l$block_1;
            }
          }
          tmp$ret$4 = false;
        }
        if (tmp$ret$4) {
          tmp$ret$2 = false;
          break $l$block_2;
        }
      }
      tmp$ret$2 = true;
    }
    if (tmp$ret$2) {
      // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
      // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
      var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
      cancellable.ra5();
      var tmp_5 = get_dialogStack();
      tmp_5.xgd(new (GenericConfirmationDialog())('Enable SMS Alerts?', 'You will receive event notifications from Stoze via SMS to your phone number. Message and data rates may apply. You can unsubscribe at any time by toggling off alerts in your Notifications Settings or replying STOP to any SMS.', VOID, 'Enable SMS Alerts', 'Nevermind', VOID, VOID, VOID, VOID, VOID, NotificationSubscriptionSettings$renderSettingsControls$lambda$slambda$slambda_0($this.rj9_1, cancellable)));
      var tmp$ret$9 = cancellable.sa5();
      var tmp_6 = returnIfSuspended(tmp$ret$9, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
    } else {
      var tmp_7 = $this.rj9_1.fj9().gah(true, $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
    }
  } else {
    var tmp_8 = $this.rj9_1.fj9().gah(false, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
  }
  return Unit_instance;
}
var NotificationSubscriptionSettings$renderSettingsControls$lambda$slambda$slambdaClass;
function NotificationSubscriptionSettings$renderSettingsControls$lambda$slambda$slambda() {
  if (NotificationSubscriptionSettings$renderSettingsControls$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($setting, $cont) {
        this.pj9_1 = $setting;
        this.qj9_1 = $cont;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    NotificationSubscriptionSettings$renderSettingsControls$lambda$slambda$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$renderSettingsControls$lambda$slambda$slambdaClass;
}
function NotificationSubscriptionSettings$renderSettingsControls$lambda$slambda$slambda_0($setting, $cont) {
  var i = new (NotificationSubscriptionSettings$renderSettingsControls$lambda$slambda$slambda())($setting, $cont);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_7($this, confirmed, $completion) {
  if (confirmed) {
    var tmp = $this.tj9_1.tj8_1.gah(true, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  // Inline function 'kotlin.coroutines.resume' call
  var this_0 = $this.uj9_1;
  // Inline function 'kotlin.Companion.success' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
  this_0.rc(tmp$ret$0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.vj9_1.tj8_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.wj9_1.fiv_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp0 = tmp_0;
    var tmp$ret$2;
    $l$block_2: {
      // Inline function 'kotlin.collections.none' call
      var tmp_1;
      if (isInterface(tmp0, Collection())) {
        tmp_1 = tmp0.i1();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$2 = true;
        break $l$block_2;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_2 = element.qj8_1;
        var tmp_2 = await_0(this_2, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        var tmp0_0 = tmp_2;
        var tmp$ret$4;
        $l$block_1: {
          // Inline function 'kotlin.collections.any' call
          var tmp_3;
          if (isInterface(tmp0_0, Collection())) {
            tmp_3 = tmp0_0.i1();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$4 = false;
            break $l$block_1;
          }
          var _iterator__ex2g4s_0 = tmp0_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            // Inline function 'com.lightningkite.reactive.context.invoke' call
            var this_3 = element_0.fj9();
            var tmp_4 = await_0(this_3, $completion);
            if (tmp_4 === get_COROUTINE_SUSPENDED())
              tmp_4 = yield tmp_4;
            if (tmp_4) {
              tmp$ret$4 = true;
              break $l$block_1;
            }
          }
          tmp$ret$4 = false;
        }
        if (tmp$ret$4) {
          tmp$ret$2 = false;
          break $l$block_2;
        }
      }
      tmp$ret$2 = true;
    }
    if (tmp$ret$2) {
      // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
      // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
      var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
      cancellable.ra5();
      var tmp_5 = get_dialogStack();
      tmp_5.xgd(new (GenericConfirmationDialog())('Enable SMS Alerts?', 'You will receive event notifications from Stoze via SMS to your phone number. Message and data rates may apply. You can unsubscribe at any time by toggling off alerts in your Notifications Settings or replying STOP to any SMS.', VOID, 'Enable SMS Alerts', 'Nevermind', VOID, VOID, VOID, VOID, VOID, NotificationSubscriptionSettings$renderSettingsControls2$slambda$slambda_0($this.vj9_1, cancellable)));
      var tmp$ret$9 = cancellable.sa5();
      var tmp_6 = returnIfSuspended(tmp$ret$9, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
    } else {
      var tmp_7 = $this.vj9_1.tj8_1.gah(true, $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
    }
  } else {
    var tmp_8 = $this.vj9_1.tj8_1.gah(false, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
  }
  return Unit_instance;
}
var NotificationSubscriptionSettings$renderSettingsControls2$slambda$slambdaClass;
function NotificationSubscriptionSettings$renderSettingsControls2$slambda$slambda() {
  if (NotificationSubscriptionSettings$renderSettingsControls2$slambda$slambdaClass === VOID) {
    class $ {
      constructor($group, $cont) {
        this.tj9_1 = $group;
        this.uj9_1 = $cont;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    NotificationSubscriptionSettings$renderSettingsControls2$slambda$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$renderSettingsControls2$slambda$slambdaClass;
}
function NotificationSubscriptionSettings$renderSettingsControls2$slambda$slambda_0($group, $cont) {
  var i = new (NotificationSubscriptionSettings$renderSettingsControls2$slambda$slambda())($group, $cont);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, confirmed, $completion) {
  if (confirmed) {
    var tmp = $this.xj9_1.fj9().gah(true, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  // Inline function 'kotlin.coroutines.resume' call
  var this_0 = $this.yj9_1;
  // Inline function 'kotlin.Companion.success' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
  this_0.rc(tmp$ret$0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.zj9_1.fj9();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.aja_1.fiv_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp0 = tmp_0;
    var tmp$ret$2;
    $l$block_2: {
      // Inline function 'kotlin.collections.none' call
      var tmp_1;
      if (isInterface(tmp0, Collection())) {
        tmp_1 = tmp0.i1();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$2 = true;
        break $l$block_2;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_2 = element.qj8_1;
        var tmp_2 = await_0(this_2, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        var tmp0_0 = tmp_2;
        var tmp$ret$4;
        $l$block_1: {
          // Inline function 'kotlin.collections.any' call
          var tmp_3;
          if (isInterface(tmp0_0, Collection())) {
            tmp_3 = tmp0_0.i1();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$4 = false;
            break $l$block_1;
          }
          var _iterator__ex2g4s_0 = tmp0_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            // Inline function 'com.lightningkite.reactive.context.invoke' call
            var this_3 = element_0.fj9();
            var tmp_4 = await_0(this_3, $completion);
            if (tmp_4 === get_COROUTINE_SUSPENDED())
              tmp_4 = yield tmp_4;
            if (tmp_4) {
              tmp$ret$4 = true;
              break $l$block_1;
            }
          }
          tmp$ret$4 = false;
        }
        if (tmp$ret$4) {
          tmp$ret$2 = false;
          break $l$block_2;
        }
      }
      tmp$ret$2 = true;
    }
    if (tmp$ret$2) {
      // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
      // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
      var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
      cancellable.ra5();
      var tmp_5 = get_dialogStack();
      tmp_5.xgd(new (GenericConfirmationDialog())('Enable SMS Alerts?', 'You will receive event notifications from Stoze via SMS to your phone number. Message and data rates may apply. You can unsubscribe at any time by toggling off alerts in your Notifications Settings or replying STOP to any SMS.', VOID, 'Enable SMS Alerts', 'Nevermind', VOID, VOID, VOID, VOID, VOID, NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambda$slambda_0($this.zj9_1, cancellable)));
      var tmp$ret$9 = cancellable.sa5();
      var tmp_6 = returnIfSuspended(tmp$ret$9, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
    } else {
      var tmp_7 = $this.zj9_1.fj9().gah(true, $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
    }
  } else {
    var tmp_8 = $this.zj9_1.fj9().gah(false, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
  }
  return Unit_instance;
}
var NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambda$slambdaClass;
function NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambda$slambda() {
  if (NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($setting, $cont) {
        this.xj9_1 = $setting;
        this.yj9_1 = $cont;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambda$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambda$slambdaClass;
}
function NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambda$slambda_0($setting, $cont) {
  var i = new (NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambda$slambda())($setting, $cont);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_11($this, $this$Action, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.bja_1.fiv_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = element.wj8_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    if (tmp_0) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp_1 = element_0.ej9($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_12($this, $this$coroutineScope, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.cja_1.fiv_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = element.wj8_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    if (tmp_0) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item = _iterator__ex2g4s_0.o1();
    var tmp$ret$5 = async($this$coroutineScope, VOID, VOID, NotificationSubscriptionSettings$save$slambda$slambda$slambda_0(item));
    destination_0.v(tmp$ret$5);
  }
  var tmp_1 = awaitAll(destination_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return flatten(tmp_1);
}
var NotificationSubscriptionSettings$save$slambda$slambda$slambdaClass;
function NotificationSubscriptionSettings$save$slambda$slambda$slambda() {
  if (NotificationSubscriptionSettings$save$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($it) {
        this.dja_1 = $it;
      }
      wah($this$async, $completion) {
        return this.dja_1.eh4($completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    NotificationSubscriptionSettings$save$slambda$slambda$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$save$slambda$slambda$slambdaClass;
}
function NotificationSubscriptionSettings$save$slambda$slambda$slambda_0($it) {
  var i = new (NotificationSubscriptionSettings$save$slambda$slambda$slambda())($it);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_13($this, $this$Action, $completion) {
  var tmp = coroutineScope(NotificationSubscriptionSettings$save$slambda$slambda_0($this.eja_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var failed = tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!failed.i1()) {
    var tmp_0 = get_dialogStack();
    tmp_0.xgd(GenericDialog().bgh("Some Changes Couldn't Be Saved", 'The following settings could not be saved and are still marked as unsaved. Please try again:\n\n' + joinToString(failed, '\n', VOID, VOID, VOID, VOID, NotificationSubscriptionSettings$save$slambda$lambda)));
  }
  return Unit_instance;
}
var NotificationSubscriptionSettings$save$slambda$slambdaClass;
function NotificationSubscriptionSettings$save$slambda$slambda() {
  if (NotificationSubscriptionSettings$save$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.cja_1 = this$0;
      }
      wah($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this, $this$coroutineScope), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    NotificationSubscriptionSettings$save$slambda$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$save$slambda$slambdaClass;
}
function NotificationSubscriptionSettings$save$slambda$slambda_0(this$0) {
  var i = new (NotificationSubscriptionSettings$save$slambda$slambda())(this$0);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
function NotificationSubscriptionSettings$save$slambda$lambda(it) {
  return '\u2022 ' + it;
}
function *_generator_invoke__zhh2q8_14($this, $this$launch, $completion) {
  var tmp;
  if ($this.fja_1.viu_1.xgj()) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_loggedInAsContractor();
    var tmp_0 = await_0(this_0, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  if (tmp) {
    get_mainPageNavigator($this.gja_1).ebw(new (ContractorNotificationSettings())());
  } else {
    var tmp_1;
    if ($this.fja_1.viu_1.equals(ProjectLens_Contractor_getInstance())) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = get_loggedInAsContractor();
      var tmp_2 = await_0(this_1, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_1 = !tmp_2;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      get_mainPageNavigator($this.gja_1).ebw(new (ClientNotificationSettings())());
    }
  }
  return Unit_instance;
}
function settingsOf($this, events) {
  return remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = events;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList().w();
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp;
      if (element instanceof Event()) {
        tmp = listOf_0(element);
      } else {
        if (element instanceof WithReminders()) {
          tmp = listOf([element.t9g(), element.u9g()]);
        } else {
          noWhenBranchMatchedException();
        }
      }
      var list = tmp;
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList().w();
    var _iterator__ex2g4s = destination.m1();
    while (_iterator__ex2g4s.n1()) {
      var element_0 = _iterator__ex2g4s.o1();
      var tmp_0;
      if ($this.viu_1.xgj()) {
        tmp_0 = !element_0.i9g_1.t1('FOR CONTRACTORS EXCLUSIVELY');
      } else {
        // Inline function 'kotlin.run' call
        var tmp$ret$3;
        $l$block_0: {
          var tmp0_elvis_lhs = $this$remember.baj($this.xiu_1);
          var tmp_1;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$3 = true;
            break $l$block_0;
          } else {
            tmp_1 = tmp0_elvis_lhs;
          }
          var role = tmp_1;
          var tmp1_elvis_lhs = get_roleRequirement(element_0.f94());
          var tmp_2;
          if (tmp1_elvis_lhs == null) {
            tmp$ret$3 = true;
            break $l$block_0;
          } else {
            tmp_2 = tmp1_elvis_lhs;
          }
          var req = tmp_2;
          tmp$ret$3 = role.d4(req) >= 0;
        }
        var roleReqMet = tmp$ret$3;
        tmp_0 = (!element_0.i9g_1.t1('FOR HOMEOWNERS EXCLUSIVELY') && roleReqMet);
      }
      if (tmp_0) {
        destination_0.v(element_0);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList().u(collectionSizeOrDefault(destination_0, 10));
    var _iterator__ex2g4s_0 = destination_0.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item = _iterator__ex2g4s_0.o1();
      var tmp$ret$8 = new (Base())(item, $this.wiu_1, $this.viu_1);
      destination_1.v(tmp$ret$8);
    }
    return destination_1;
  });
}
function groupOf($this, name, events) {
  var settings = settingsOf($this, events.slice());
  return remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(settings).i1() ? null : listOf_0(new (Group())(name, settings)));
}
function renderSettingsControls($this, _this__u8e3s4, group) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  var tmp = view_0.ibb(view_0.ibb(get_expanding(view_0), get_atBottom(view_0)), get_bold(view_0));
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content = group.pj8_1;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_0 = view_1.tb5_1;
  var tmp_1;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_1 = '\xA0';
  } else {
    tmp_1 = content;
  }
  tmp_0.fbu(tmp_1);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.xbm(false);
  var tmp_2 = shownWhen(view_2, VOID, ($this$shownWhen) => $this$shownWhen.baj(group.rj8_1));
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$6 = view_2.hbb(ButtonSemantic_getInstance());
  var tmp_3 = view_2.ibb(tmp_2, tmp$ret$6);
  var tmp_4 = view_2.ibb(tmp_3, hintPopover(view_2, VOID, NotificationSubscriptionSettings$renderSettingsControls$lambda));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  dynamicTheme(view_3, ($this$dynamicTheme) => $this$dynamicTheme.baj(group.sj8_1) ? SelectedSemantic_getInstance() : UnselectedSemantic_getInstance());
  icon(view_3, resize(Companion_getInstance_0().wcg_1, get_rem(1.5)), 'email');
  onClick(view_3, VOID, VOID, NotificationSubscriptionSettings$renderSettingsControls$slambda_0(group));
  view_2.fbb(p_3, view_3);
  view_2.jbb(tmp_4, view_3);
  var tmp_5 = view_2.ibb(shownWhen(view_2, VOID, ($this$shownWhen) => !$this$shownWhen.baj(group.rj8_1)), get_centered(view_2));
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$10 = view_2.hbb(ButtonSemantic_getInstance());
  var tmp_6 = view_2.ibb(tmp_5, tmp$ret$10);
  var tmp_7 = view_2.ibb(tmp_6, hintPopover(view_2, VOID, NotificationSubscriptionSettings$renderSettingsControls$lambda_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (ToggleButton())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.ebb(p_4, view_4);
  icon(view_4, resize(Companion_getInstance_0().wcg_1, get_rem(1.5)), 'email');
  view_4.xah(view_4.ncq_1, group.sj8_1);
  view_2.fbb(p_4, view_4);
  view_2.jbb(tmp_7, view_4);
  var tmp_8 = hintPopover(view_2, VOID, NotificationSubscriptionSettings$renderSettingsControls$lambda_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Frame())(view_2.pc());
  var tmp0_elvis_lhs_5 = view_2.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
  view_2.ebb(p_5, view_5);
  var tmp_9 = get_centered(view_5);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$14 = view_5.hbb(ButtonSemantic_getInstance());
  var tmp_10 = view_5.ibb(tmp_9, tmp$ret$14);
  // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (ToggleButton())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.ebb(p_6, view_6);
  icon(view_6, resize(get_messageBubble(Companion_getInstance_0()), get_rem(1.5)), 'sms');
  // Inline function 'com.lightningkite.kiteui.views.direct.ToggleButton.enabled' call
  var tmp0 = view_6.mcq_1.zb3_1;
  // Inline function 'com.lightningkite.kiteui.views.disabled' call
  var value = !false;
  tmp0.ib7_1.disabled = value;
  view_6.xah(view_6.ncq_1, group.tj8_1);
  view_5.fbb(p_6, view_6);
  view_5.jbb(tmp_10, view_6);
  var tmp_11 = view_5.hbb(NoHoverSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Button())(view_5.pc());
  var tmp0_elvis_lhs_7 = view_5.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
  view_5.ebb(p_7, view_7);
  var tmp_12 = KMutableProperty0();
  var tmp_13 = Button$_get_enabled_$ref_61t7nx(view_7);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_12, tmp_13, Button$_set_enabled_$ref_o8kynz(view_7));
  reactiveScope(view_7, ($this$reactiveScope) => {
    var tmp$ret$20 = $this$reactiveScope.baj($this$reactiveScope.baj(get_session()).pfw_1).r88_1 || $this$reactiveScope.baj(group.tj8_1);
    this_0.set(tmp$ret$20);
    return Unit_instance;
  });
  onClick(view_7, VOID, VOID, NotificationSubscriptionSettings$renderSettingsControls$slambda_2(group, $this));
  view_5.fbb(p_7, view_7);
  view_5.jbb(tmp_11, view_7);
  view_2.fbb(p_5, view_5);
  view_2.jbb(tmp_8, view_5);
  var tmp_14 = get_centered(view_2);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$28 = view_2.hbb(ButtonSemantic_getInstance());
  var tmp_15 = view_2.ibb(tmp_14, tmp$ret$28);
  var tmp_16 = view_2.ibb(tmp_15, hintPopover(view_2, VOID, NotificationSubscriptionSettings$renderSettingsControls$lambda_2));
  // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (ToggleButton())(view_2.pc());
  var tmp0_elvis_lhs_8 = view_2.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_2 : tmp0_elvis_lhs_8;
  view_2.ebb(p_8, view_8);
  icon(view_8, resize(get_notificationBell(Companion_getInstance_0()), get_rem(1.5)), 'push notifications');
  view_8.xah(view_8.ncq_1, group.uj8_1);
  view_2.fbb(p_8, view_8);
  view_2.jbb(tmp_16, view_8);
  view_0.fbb(p_2, view_2);
  view.fbb(p_0, view_0);
  greySeparator(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_9 = view.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view : tmp0_elvis_lhs_9;
  view.ebb(p_9, view_9);
  view_9.xbm(true);
  forEach(view_9, group.qj8_1, ($this$forEach, setting) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEach.pc());
    var tmp0_elvis_lhs = $this$forEach.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
    $this$forEach.ebb(p, view);
    view.xbm(false);
    if (get_viewIsWide(view)) {
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (Space())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view.fbb(p_0, view_0);
    }
    var tmp = view.ibb(get_centered(view), get_expanding(view));
    var tmp_0 = view.ibb(tmp, shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(setting.dj9())));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    view_1.xbm(false);
    view_1.zb8(get_rem(0.1));
    body(view_1, setting.k20());
    view_1.jbb(colored(view_1, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_1, '*'));
    view.fbb(p_1, view_1);
    view.jbb(tmp_0, view_1);
    var tmp_1 = view.ibb(get_centered(view), get_expanding(view));
    view.jbb(view.ibb(tmp_1, shownWhen(view, VOID, ($this$shownWhen) => !$this$shownWhen.baj(setting.dj9()))), body(view, setting.k20()));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    view_2.xbm(false);
    var tmp_2 = shownWhen(view_2, VOID, ($this$shownWhen) => $this$shownWhen.baj(setting.dj9()));
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var tmp$ret$47 = view_2.hbb(ButtonSemantic_getInstance());
    var tmp_3 = view_2.ibb(view_2.ibb(tmp_2, tmp$ret$47), get_padded(view_2));
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Frame())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    var tmp_4 = view_3.ibb(get_centered(view_3), colored(view_3, AppColors_getInstance().kfz_1.wg9_1));
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (IconView())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.ebb(p_4, view_4);
    view_4.qbt(resize(get_lock(Companion_getInstance_0()), get_rem(1.5)));
    view_4.ebu('required');
    view_3.fbb(p_4, view_4);
    view_3.jbb(tmp_4, view_4);
    view_2.fbb(p_3, view_3);
    view_2.jbb(tmp_3, view_3);
    var tmp_5 = shownWhen(view_2, VOID, ($this$shownWhen) => !$this$shownWhen.baj(setting.dj9()));
    view_2.jbb(tmp_5, renderSettingsControls$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$customToggle_ylldhv(view_2, ($this$customToggle) => {
      $this$customToggle.xah($this$customToggle.ncq_1, setting.l92());
      return Unit_instance;
    }));
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var tmp$ret$54 = view_2.hbb(ButtonSemantic_getInstance());
    var tmp_6 = view_2.ibb(tmp$ret$54, get_padded(view_2));
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (Frame())(view_2.pc());
    var tmp0_elvis_lhs_5 = view_2.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
    view_2.ebb(p_5, view_5);
    var tmp_7 = sizeConstraints(view_5, VOID, VOID, VOID, VOID, VOID, get_rem(1.5), get_rem(1.5));
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var tmp$ret$55 = view_5.hbb(ButtonSemantic_getInstance());
    var tmp_8 = view_5.ibb(tmp_7, tmp$ret$55);
    // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (ToggleButton())(view_5.pc());
    var tmp0_elvis_lhs_6 = view_5.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
    view_5.ebb(p_6, view_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.ToggleButton.enabled' call
    var tmp0 = view_6.mcq_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !false;
    tmp0.ib7_1.disabled = value;
    view_6.xah(view_6.ncq_1, setting.fj9());
    view_5.fbb(p_6, view_6);
    view_5.jbb(tmp_8, view_6);
    var tmp_9 = view_5.hbb(NoHoverSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (Button())(view_5.pc());
    var tmp0_elvis_lhs_7 = view_5.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
    view_5.ebb(p_7, view_7);
    var tmp_10 = KMutableProperty0();
    var tmp_11 = Button$_get_enabled_$ref_61t7nx_0(view_7);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('enabled', 0, tmp_10, tmp_11, Button$_set_enabled_$ref_o8kynz_0(view_7));
    reactiveScope(view_7, ($this$reactiveScope) => {
      var tmp$ret$61 = $this$reactiveScope.baj($this$reactiveScope.baj(get_session()).pfw_1).r88_1 || $this$reactiveScope.baj(setting.fj9());
      this_0.set(tmp$ret$61);
      return Unit_instance;
    });
    onClick(view_7, VOID, VOID, NotificationSubscriptionSettings$renderSettingsControls$lambda$slambda_0(setting, $this));
    view_5.fbb(p_7, view_7);
    view_5.jbb(tmp_9, view_7);
    view_2.fbb(p_5, view_5);
    view_2.jbb(tmp_6, view_5);
    renderSettingsControls$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$customToggle_ylldhv(view_2, ($this$customToggle) => {
      $this$customToggle.xah($this$customToggle.ncq_1, setting.gj9());
      return Unit_instance;
    });
    view.fbb(p_2, view_2);
    $this$forEach.fbb(p, view);
    return Unit_instance;
  });
  view.fbb(p_9, view_9);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderSettingsControls2($this, _this__u8e3s4, group) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  var tmp = view_0.ibb(view_0.ibb(get_expanding(view_0), get_atBottom(view_0)), get_bold(view_0));
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content = group.pj8_1;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_0 = view_1.tb5_1;
  var tmp_1;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_1 = '\xA0';
  } else {
    tmp_1 = content;
  }
  tmp_0.fbu(tmp_1);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.xbm(true);
  view_2.jbb(view_2.ibb(get_centered(view_2), colored(view_2, AppColors_getInstance().cfz_1.xg9_1)), icon(view_2, resize(get_envelope(Companion_getInstance_0()), get_rem(1.5)), 'email'));
  var tmp_2 = sizeConstraints(view_2, VOID, VOID, VOID, VOID, VOID, get_rem_0(3));
  // Inline function 'com.lightningkite.kiteui.views.direct.switch' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Switch())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.xah(view_3.cck_1, group.sj8_1);
  view_2.fbb(p_3, view_3);
  view_2.jbb(tmp_2, view_3);
  view_0.fbb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_4 = view_0.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
  view_0.ebb(p_4, view_4);
  view_4.xbm(true);
  view_4.jbb(view_4.ibb(get_centered(view_4), colored(view_4, AppColors_getInstance().cfz_1.xg9_1)), icon(view_4, resize(get_speechBubble(Companion_getInstance_0()), get_rem(1.5)), 'sms'));
  var tmp_3 = sizeConstraints(view_4, VOID, VOID, VOID, VOID, VOID, get_rem_0(3));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Frame())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.switch' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Switch())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.ebb(p_6, view_6);
  // Inline function 'com.lightningkite.kiteui.views.direct.Switch.enabled' call
  var tmp0 = view_6.tb5_1.zb3_1;
  // Inline function 'com.lightningkite.kiteui.views.disabled' call
  var value = !false;
  tmp0.ib7_1.disabled = value;
  view_6.xah(view_6.cck_1, group.tj8_1);
  view_5.fbb(p_6, view_6);
  var tmp_4 = view_5.hbb(NoHoverSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Button())(view_5.pc());
  var tmp0_elvis_lhs_7 = view_5.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
  view_5.ebb(p_7, view_7);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = Button$_get_enabled_$ref_61t7nx_1(view_7);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_5, tmp_6, Button$_set_enabled_$ref_o8kynz_1(view_7));
  reactiveScope(view_7, ($this$reactiveScope) => {
    var tmp$ret$18 = $this$reactiveScope.baj($this$reactiveScope.baj(get_session()).pfw_1).r88_1 || $this$reactiveScope.baj(group.tj8_1);
    this_0.set(tmp$ret$18);
    return Unit_instance;
  });
  onClick(view_7, VOID, VOID, NotificationSubscriptionSettings$renderSettingsControls2$slambda_0(group, $this));
  view_5.fbb(p_7, view_7);
  view_5.jbb(tmp_4, view_7);
  view_4.fbb(p_5, view_5);
  view_4.jbb(tmp_3, view_5);
  view_0.fbb(p_4, view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_8 = view_0.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_0 : tmp0_elvis_lhs_8;
  view_0.ebb(p_8, view_8);
  view_8.xbm(true);
  view_8.jbb(view_8.ibb(get_centered(view_8), colored(view_8, AppColors_getInstance().cfz_1.xg9_1)), icon(view_8, resize(get_bell(Companion_getInstance_0()), get_rem(1.5)), 'push'));
  var tmp_7 = sizeConstraints(view_8, VOID, VOID, VOID, VOID, VOID, get_rem_0(3));
  // Inline function 'com.lightningkite.kiteui.views.direct.switch' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (Switch())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.ebb(p_9, view_9);
  view_9.xah(view_9.cck_1, group.uj8_1);
  view_8.fbb(p_9, view_9);
  view_8.jbb(tmp_7, view_9);
  view_0.fbb(p_8, view_8);
  view.fbb(p_0, view_0);
  greySeparator(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_10 = view.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view : tmp0_elvis_lhs_10;
  view.ebb(p_10, view_10);
  view_10.xbm(true);
  forEach(view_10, group.qj8_1, ($this$forEach, setting) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEach.pc());
    var tmp0_elvis_lhs = $this$forEach.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
    $this$forEach.ebb(p, view);
    view.xbm(false);
    if (get_viewIsWide(view)) {
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (Space())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view.fbb(p_0, view_0);
    }
    var tmp = get_expanding(view);
    var tmp_0 = view.ibb(tmp, shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(setting.dj9())));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    view_1.xbm(false);
    view_1.zb8(get_rem(0.1));
    body(view_1, setting.k20());
    view_1.jbb(colored(view_1, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_1, '*'));
    view.fbb(p_1, view_1);
    view.jbb(tmp_0, view_1);
    var tmp_1 = get_expanding(view);
    view.jbb(view.ibb(tmp_1, shownWhen(view, VOID, ($this$shownWhen) => !$this$shownWhen.baj(setting.dj9()))), body(view, setting.k20()));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    view_2.xbm(false);
    var tmp_2 = sizeConstraints(view_2, VOID, VOID, VOID, VOID, VOID, get_rem_0(3));
    var tmp_3 = view_2.ibb(view_2.ibb(tmp_2, shownWhen(view_2, VOID, ($this$shownWhen) => $this$shownWhen.baj(setting.dj9()))), colored(view_2, AppColors_getInstance().cfz_1.xg9_1));
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Frame())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    view_3.jbb(get_centered(view_3), icon(view_3, get_padlock(Companion_getInstance_0()), 'required'));
    view_2.fbb(p_3, view_3);
    view_2.jbb(tmp_3, view_3);
    var tmp_4 = shownWhen(view_2, VOID, ($this$shownWhen) => !$this$shownWhen.baj(setting.dj9()));
    view_2.jbb(tmp_4, renderSettingsControls2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$customToggle_wpnrnr(view_2, ($this$customToggle) => {
      $this$customToggle.xah($this$customToggle.cck_1, setting.l92());
      return Unit_instance;
    }));
    var tmp_5 = sizeConstraints(view_2, VOID, VOID, VOID, VOID, VOID, get_rem_0(3));
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (Frame())(view_2.pc());
    var tmp0_elvis_lhs_4 = view_2.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
    view_2.ebb(p_4, view_4);
    // Inline function 'com.lightningkite.kiteui.views.direct.switch' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (Switch())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.ebb(p_5, view_5);
    // Inline function 'com.lightningkite.kiteui.views.direct.Switch.enabled' call
    var tmp0 = view_5.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !false;
    tmp0.ib7_1.disabled = value;
    view_5.xah(view_5.cck_1, setting.fj9());
    view_4.fbb(p_5, view_5);
    var tmp_6 = view_4.hbb(NoHoverSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (Button())(view_4.pc());
    var tmp0_elvis_lhs_6 = view_4.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
    view_4.ebb(p_6, view_6);
    var tmp_7 = KMutableProperty0();
    var tmp_8 = Button$_get_enabled_$ref_61t7nx_2(view_6);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('enabled', 0, tmp_7, tmp_8, Button$_set_enabled_$ref_o8kynz_2(view_6));
    reactiveScope(view_6, ($this$reactiveScope) => {
      var tmp$ret$56 = $this$reactiveScope.baj($this$reactiveScope.baj(get_session()).pfw_1).r88_1 || $this$reactiveScope.baj(setting.fj9());
      this_0.set(tmp$ret$56);
      return Unit_instance;
    });
    onClick(view_6, VOID, VOID, NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambda_0(setting, $this));
    view_4.fbb(p_6, view_6);
    view_4.jbb(tmp_6, view_6);
    view_2.fbb(p_4, view_4);
    view_2.jbb(tmp_5, view_4);
    renderSettingsControls2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$customToggle_wpnrnr(view_2, ($this$customToggle) => {
      $this$customToggle.xah($this$customToggle.cck_1, setting.gj9());
      return Unit_instance;
    });
    view.fbb(p_2, view_2);
    $this$forEach.fbb(p, view);
    return Unit_instance;
  });
  view.fbb(p_10, view_10);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderSettingsControls$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$customToggle_ylldhv($this_row, setup) {
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$0 = $this_row.hbb(ButtonSemantic_getInstance());
  var tmp = $this_row.ibb(tmp$ret$0, get_padded($this_row));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())($this_row.pc());
  var tmp0_elvis_lhs = $this_row.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this_row : tmp0_elvis_lhs;
  $this_row.ebb(p, view);
  var tmp_0 = view.ibb(get_centered(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(1.5), get_rem(1.5)));
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$1 = view.hbb(ButtonSemantic_getInstance());
  var tmp_1 = view.ibb(tmp_0, tmp$ret$1);
  // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (ToggleButton())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  setup(view_0);
  view.fbb(p_0, view_0);
  view.jbb(tmp_1, view_0);
  $this_row.fbb(p, view);
  return $this_row.jbb(tmp, view);
}
function renderSettingsControls2$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$customToggle_wpnrnr($this_row, setup) {
  var tmp = sizeConstraints($this_row, VOID, VOID, VOID, VOID, VOID, get_rem_0(3));
  // Inline function 'com.lightningkite.kiteui.views.direct.switch' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Switch())($this_row.pc());
  var tmp0_elvis_lhs = $this_row.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this_row : tmp0_elvis_lhs;
  $this_row.ebb(p, view);
  setup(view);
  $this_row.fbb(p, view);
  return $this_row.jbb(tmp, view);
}
function NotificationSubscriptionSettings$subscriptions$lambda($this$remember) {
  var session = $this$remember.baj(get_session());
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(EventSubscription()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), false));
  var tmp$ret$0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  // Inline function 'kotlin.let' call
  // Inline function 'com.crowpay.notifications._id' call
  var this_0 = new (DataClassPathSelf())(tmp$ret$0);
  // Inline function 'kotlin.let' call
  var tmp_0 = ensureNotNull(tryTypeParameterSerializers(this_0.j2j()))[0];
  // Inline function 'com.crowpay.notifications.user' call
  var this_1 = this_0.prop(new (EventSubscription__id())(isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE()));
  // Inline function 'kotlin.let' call
  var tmp_1 = ensureNotNull(tryTypeParameterSerializers(this_1.j2j()))[0];
  var tmp$ret$7 = this_1.prop(new (UserEventType_user())(isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE()));
  var tmp$ret$10 = eq(tmp$ret$7, session.efv_1);
  // Inline function 'kotlin.collections.associateBy' call
  var this_2 = $this$remember.baj(session.lfw_1.feo(new (Query())(tmp$ret$10, VOID, VOID, 2147483647)));
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s = this_2.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp$ret$11 = element.j8k_1;
    destination.s3(tmp$ret$11, element);
  }
  return destination;
}
function NotificationSubscriptionSettings$myMemberRole$lambda($this$remember) {
  var tmp0_safe_receiver = $this$remember.baj($this$remember.baj(get_session()).pfw_1).m88_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j8c_1;
}
function NotificationSubscriptionSettings$renderSettingsControls$lambda($this$hintPopover) {
  body($this$hintPopover, 'Send notifications via email');
  return Unit_instance;
}
var NotificationSubscriptionSettings$renderSettingsControls$slambdaClass;
function NotificationSubscriptionSettings$renderSettingsControls$slambda() {
  if (NotificationSubscriptionSettings$renderSettingsControls$slambdaClass === VOID) {
    class $ {
      constructor($group) {
        this.kj9_1 = $group;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    NotificationSubscriptionSettings$renderSettingsControls$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$renderSettingsControls$slambdaClass;
}
function NotificationSubscriptionSettings$renderSettingsControls$slambda_0($group) {
  var i = new (NotificationSubscriptionSettings$renderSettingsControls$slambda())($group);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function NotificationSubscriptionSettings$renderSettingsControls$lambda_0($this$hintPopover) {
  body($this$hintPopover, 'Send notifications via email');
  return Unit_instance;
}
function NotificationSubscriptionSettings$renderSettingsControls$lambda_1($this$hintPopover) {
  body($this$hintPopover, 'Send notifications via sms');
  return Unit_instance;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var NotificationSubscriptionSettings$renderSettingsControls$slambdaClass_0;
function NotificationSubscriptionSettings$renderSettingsControls$slambda_1() {
  if (NotificationSubscriptionSettings$renderSettingsControls$slambdaClass_0 === VOID) {
    class $ {
      constructor($group, this$0) {
        this.nj9_1 = $group;
        this.oj9_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    NotificationSubscriptionSettings$renderSettingsControls$slambdaClass_0 = $;
  }
  return NotificationSubscriptionSettings$renderSettingsControls$slambdaClass_0;
}
function NotificationSubscriptionSettings$renderSettingsControls$slambda_2($group, this$0) {
  var i = new (NotificationSubscriptionSettings$renderSettingsControls$slambda_1())($group, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function NotificationSubscriptionSettings$renderSettingsControls$lambda_2($this$hintPopover) {
  body($this$hintPopover, 'Send notifications via push notifications');
  return Unit_instance;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var NotificationSubscriptionSettings$renderSettingsControls$lambda$slambdaClass;
function NotificationSubscriptionSettings$renderSettingsControls$lambda$slambda() {
  if (NotificationSubscriptionSettings$renderSettingsControls$lambda$slambdaClass === VOID) {
    class $ {
      constructor($setting, this$0) {
        this.rj9_1 = $setting;
        this.sj9_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    NotificationSubscriptionSettings$renderSettingsControls$lambda$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$renderSettingsControls$lambda$slambdaClass;
}
function NotificationSubscriptionSettings$renderSettingsControls$lambda$slambda_0($setting, this$0) {
  var i = new (NotificationSubscriptionSettings$renderSettingsControls$lambda$slambda())($setting, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var NotificationSubscriptionSettings$renderSettingsControls2$slambdaClass;
function NotificationSubscriptionSettings$renderSettingsControls2$slambda() {
  if (NotificationSubscriptionSettings$renderSettingsControls2$slambdaClass === VOID) {
    class $ {
      constructor($group, this$0) {
        this.vj9_1 = $group;
        this.wj9_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    NotificationSubscriptionSettings$renderSettingsControls2$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$renderSettingsControls2$slambdaClass;
}
function NotificationSubscriptionSettings$renderSettingsControls2$slambda_0($group, this$0) {
  var i = new (NotificationSubscriptionSettings$renderSettingsControls2$slambda())($group, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambdaClass;
function NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambda() {
  if (NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambdaClass === VOID) {
    class $ {
      constructor($setting, this$0) {
        this.zj9_1 = $setting;
        this.aja_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambdaClass;
}
function NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambda_0($setting, this$0) {
  var i = new (NotificationSubscriptionSettings$renderSettingsControls2$lambda$slambda())($setting, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var NotificationSubscriptionSettings$discard$slambdaClass;
function NotificationSubscriptionSettings$discard$slambda() {
  if (NotificationSubscriptionSettings$discard$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.bja_1 = this$0;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    NotificationSubscriptionSettings$discard$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$discard$slambdaClass;
}
function NotificationSubscriptionSettings$discard$slambda_0(this$0) {
  var i = new (NotificationSubscriptionSettings$discard$slambda())(this$0);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var NotificationSubscriptionSettings$save$slambdaClass;
function NotificationSubscriptionSettings$save$slambda() {
  if (NotificationSubscriptionSettings$save$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.eja_1 = this$0;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    NotificationSubscriptionSettings$save$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$save$slambdaClass;
}
function NotificationSubscriptionSettings$save$slambda_0(this$0) {
  var i = new (NotificationSubscriptionSettings$save$slambda())(this$0);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var NotificationSubscriptionSettings$render$slambdaClass;
function NotificationSubscriptionSettings$render$slambda() {
  if (NotificationSubscriptionSettings$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_render) {
        this.fja_1 = this$0;
        this.gja_1 = $this_render;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    NotificationSubscriptionSettings$render$slambdaClass = $;
  }
  return NotificationSubscriptionSettings$render$slambdaClass;
}
function NotificationSubscriptionSettings$render$slambda_0(this$0, $this_render) {
  var i = new (NotificationSubscriptionSettings$render$slambda())(this$0, $this_render);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function NotificationSubscriptionSettings$render$lambda($documentType) {
  return () => new (ViewLegalDocument())($documentType);
}
var NotificationSubscriptionSettingsClass;
function NotificationSubscriptionSettings() {
  if (NotificationSubscriptionSettingsClass === VOID) {
    class $ {
      constructor(lens) {
        this.viu_1 = lens;
        var tmp = this;
        tmp.wiu_1 = remember(VOID, VOID, VOID, NotificationSubscriptionSettings$subscriptions$lambda);
        var tmp_0 = this;
        tmp_0.xiu_1 = remember(VOID, VOID, VOID, NotificationSubscriptionSettings$myMemberRole$lambda);
        var tmp_1 = this;
        // Inline function 'kotlin.run' call
        var $this$run = SharedEvents_getInstance();
        var tmp$ret$1 = settingsOf(this, [$this$run.v9g_1, $this$run.w9g_1, $this$run.x9g_1, $this$run.y9g_1, $this$run.z9g_1, $this$run.a9h_1, $this$run.c9h_1, $this$run.d9h_1, $this$run.e9h_1]);
        tmp_1.yiu_1 = new (Group())('General Project Alerts', tmp$ret$1);
        var tmp_2 = this;
        // Inline function 'kotlin.run' call
        var $this$run_0 = SharedEvents_getInstance();
        var tmp$ret$3 = settingsOf(this, [$this$run_0.f9h_1, $this$run_0.g9h_1, $this$run_0.h9h_1, $this$run_0.i9h_1, $this$run_0.j9h_1, $this$run_0.k9h_1]);
        tmp_2.ziu_1 = new (Group())('Work Item Alerts', tmp$ret$3);
        var tmp_3 = this;
        // Inline function 'kotlin.run' call
        var $this$run_1 = SharedEvents_getInstance();
        var tmp$ret$5 = settingsOf(this, [$this$run_1.m9h_1, $this$run_1.n9h_1]);
        tmp_3.aiv_1 = new (Group())('Bank and Account Setup', tmp$ret$5);
        var tmp_4 = this;
        // Inline function 'kotlin.run' call
        var $this$run_2 = SharedEvents_getInstance();
        var tmp$ret$7 = settingsOf(this, [$this$run_2.o9h_1, $this$run_2.p9h_1, $this$run_2.q9h_1]);
        tmp_4.biv_1 = new (Group())('Escrow Alerts', tmp$ret$7);
        var tmp_5 = this;
        // Inline function 'kotlin.run' call
        var $this$run_3 = SharedEvents_getInstance();
        var tmp$ret$9 = settingsOf(this, [$this$run_3.r9h_1, $this$run_3.s9h_1, $this$run_3.t9h_1, $this$run_3.u9h_1, $this$run_3.v9h_1]);
        tmp_5.civ_1 = new (Group())('Draws', tmp$ret$9);
        var tmp_6 = this;
        // Inline function 'kotlin.run' call
        var $this$run_4 = SharedEvents_getInstance();
        // Inline function 'kotlin.let' call
        var groups = listOfNotNull([settingsOf(this, [$this$run_4.w9h_1]), groupOf(this, 'Change Item Approved', [$this$run_4.x9h_1, $this$run_4.z9h_1]), groupOf(this, 'Change Item Rejected', [$this$run_4.y9h_1, $this$run_4.a9i_1]), settingsOf(this, [$this$run_4.b9i_1, $this$run_4.c9i_1])]);
        var tmp$ret$20 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.onEach' call
          // Inline function 'kotlin.apply' call
          var this_0 = groups;
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            $this$remember.aaj(element);
          }
          // Inline function 'kotlin.collections.flatMap' call
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s_0 = this_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            var tmp0_elvis_lhs = $this$remember.baj(element_0);
            var list = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
            addAll(destination, list);
          }
          return destination;
        });
        tmp_6.div_1 = new (Group())('Change Alerts', tmp$ret$20);
        var tmp_7 = this;
        // Inline function 'kotlin.run' call
        var $this$run_5 = SharedEvents_getInstance();
        // Inline function 'kotlin.let' call
        var groups_0 = listOfNotNull([settingsOf(this, [$this$run_5.d9i_1, $this$run_5.e9i_1, $this$run_5.f9i_1, $this$run_5.g9i_1, $this$run_5.h9i_1, $this$run_5.i9i_1, $this$run_5.j9i_1]), groupOf(this, 'Refund Processing', [$this$run_5.k9i_1, $this$run_5.l9i_1]), groupOf(this, 'Refund Complete', [$this$run_5.m9i_1, $this$run_5.n9i_1])]);
        var tmp$ret$31 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.onEach' call
          // Inline function 'kotlin.apply' call
          var this_0 = groups_0;
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            $this$remember.aaj(element);
          }
          // Inline function 'kotlin.collections.flatMap' call
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s_0 = this_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            var tmp0_elvis_lhs = $this$remember.baj(element_0);
            var list = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
            addAll(destination, list);
          }
          return destination;
        });
        tmp_7.eiv_1 = new (Group())('Payments', tmp$ret$31);
        var tmp_8 = this;
        tmp_8.fiv_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = listOf([this.yiu_1, this.ziu_1, this.aiv_1, this.biv_1, this.civ_1, this.div_1, this.eiv_1]);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!$this$remember.baj(element.qj8_1).i1()) {
              destination.v(element);
            }
          }
          return destination;
        });
        var tmp_9 = this;
        tmp_9.giv_1 = Action('Discard changes', VOID, NotificationSubscriptionSettings$discard$slambda_0(this));
        var tmp_10 = this;
        tmp_10.hiv_1 = Action('Save changes', VOID, NotificationSubscriptionSettings$save$slambda_0(this));
      }
      ziw(writer) {
        // Inline function 'kotlin.with' call
        var tmp = writer.ibb(writer.hbb(PurpleSelectButtons_getInstance()), sizeConstraints(writer, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(writer.pc());
        var tmp0_elvis_lhs = writer.cbb_1;
        var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
        writer.ebb(p, view);
        view.xbm(true);
        view.zb8(times(get_AppDimensions().zg1_1, 2));
        forEach(view, this.fiv_1, ($this$forEach, group) => {
          if (get_viewIsNarrow($this$forEach))
            renderSettingsControls(this, $this$forEach, group);
          else
            renderSettingsControls2(this, $this$forEach, group);
          return Unit_instance;
        });
        writer.fbb(p, view);
        return writer.jbb(tmp, view);
      }
      hja(writer) {
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(writer.pc());
        var tmp0_elvis_lhs = writer.cbb_1;
        var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
        writer.ebb(p, view);
        view.xbm(false);
        shownDefaultFalse(view, ($this$shownDefaultFalse) => {
          var tmp0 = $this$shownDefaultFalse.baj(this.fiv_1);
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if ($this$shownDefaultFalse.baj(element.wj8_1)) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          return tmp$ret$0;
        });
        var tmp = get_secondaryButton(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Button())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        specCenteredText(view_0, 'Discard');
        view_0.mbg(this.giv_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        var tmp_0 = get_primaryButton(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Button())(view.pc());
        var tmp0_elvis_lhs_1 = view.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.ebb(p_1, view_1);
        specCenteredText(view_1, 'Save Changes');
        view_1.mbg(this.hiv_1);
        view.fbb(p_1, view_1);
        view.jbb(tmp_0, view_1);
        writer.fbb(p, view);
        return view;
      }
      ud6(_this__u8e3s4) {
        launch(_this__u8e3s4, VOID, VOID, NotificationSubscriptionSettings$render$slambda_0(this, _this__u8e3s4));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        var tmp = get_scrolling(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        title(view_1, 'Notification Settings');
        // Inline function 'com.lightningkite.kiteui.views.direct.rowWrapping' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowWrapping())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        var _iterator__ex2g4s = get_entries().m1();
        while (_iterator__ex2g4s.n1()) {
          var documentType = _iterator__ex2g4s.o1();
          var tmp_0 = get_compact(view_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (RowOrCol())(view_2.pc());
          var tmp0_elvis_lhs_3 = view_2.cbb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
          view_2.ebb(p_3, view_3);
          view_3.xbm(false);
          var tmp_1 = view_3.ibb(get_centered(view_3), get_textButton(view_3));
          // Inline function 'com.lightningkite.kiteui.views.direct.link' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (Link())(view_3.pc());
          var tmp0_elvis_lhs_4 = view_3.cbb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
          view_3.ebb(p_4, view_4);
          // Inline function 'com.crowpay.views.theming.subTitle' call
          var content = '\u2022 ' + documentType.e91_1;
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (TextView())(view_4.pc());
          var tmp0_elvis_lhs_5 = view_4.cbb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
          view_4.ebb(p_5, view_5);
          view_5.jba(view_5.ob6_1.ybe(SubtitleSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_2 = view_5.tb5_1;
          var tmp_3;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(content) === 0) {
            tmp_3 = '\xA0';
          } else {
            tmp_3 = content;
          }
          tmp_2.fbu(tmp_3);
          view_4.fbb(p_5, view_5);
          view_4.ibw(NotificationSubscriptionSettings$render$lambda(documentType));
          view_3.fbb(p_4, view_4);
          view_3.jbb(tmp_1, view_4);
          view_2.fbb(p_3, view_3);
          view_2.jbb(tmp_0, view_3);
        }
        view_1.fbb(p_2, view_2);
        this.ziw(view_1);
        view_0.fbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Space())(view_0.pc(), 2.0);
        var tmp0_elvis_lhs_6 = view_0.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_0 : tmp0_elvis_lhs_6;
        view_0.ebb(p_6, view_6);
        view_0.fbb(p_6, view_6);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        var tmp_4 = get_atBottomEnd(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_7 = view.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
        view.ebb(p_7, view_7);
        this.hja(view_7);
        view.fbb(p_7, view_7);
        view.jbb(tmp_4, view_7);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'NotificationSubscriptionSettings', VOID, VOID, [Page()]);
    NotificationSubscriptionSettingsClass = $;
  }
  return NotificationSubscriptionSettingsClass;
}
var ClientNotificationSettingsClass;
function ClientNotificationSettings() {
  if (ClientNotificationSettingsClass === VOID) {
    class $ {
      constructor() {
        this.ija_1 = new (NotificationSubscriptionSettings())(ProjectLens_Customer_getInstance());
      }
      ud6(_this__u8e3s4) {
        return this.ija_1.ud6(_this__u8e3s4);
      }
      ucv() {
        return this.ija_1.ucv();
      }
    }
    initMetadataForClass($, 'ClientNotificationSettings', ClientNotificationSettings, VOID, [Page()]);
    ClientNotificationSettingsClass = $;
  }
  return ClientNotificationSettingsClass;
}
var ContractorNotificationSettingsClass;
function ContractorNotificationSettings() {
  if (ContractorNotificationSettingsClass === VOID) {
    class $ {
      constructor() {
        this.jja_1 = new (NotificationSubscriptionSettings())(ProjectLens_Contractor_getInstance());
      }
      ud6(_this__u8e3s4) {
        return this.jja_1.ud6(_this__u8e3s4);
      }
      ucv() {
        return this.jja_1.ucv();
      }
    }
    initMetadataForClass($, 'ContractorNotificationSettings', ContractorNotificationSettings, VOID, [Page()]);
    ContractorNotificationSettingsClass = $;
  }
  return ContractorNotificationSettingsClass;
}
//region block: exports
export {
  ClientNotificationSettings as ClientNotificationSettings1m4d3pbyj6bl9,
  ContractorNotificationSettings as ContractorNotificationSettings1wc9spupzmetl,
  NotificationSubscriptionSettings as NotificationSubscriptionSettings19nypb7tkeyts,
};
//endregion

//# sourceMappingURL=NotificationSubscriptionSettings.mjs.map
